import {CHARM} from "../../constants";

/**
 * Given on the state, set the right variation on the product
 */

export default function variantConnector(store) {
    let {input, input2, goldColor, charmOrientation} = store.getState();

    if (!/au/.test(location.hostname)) {
        console.warn('Variant connector is off in local environment');
    }

    if (charmOrientation === CHARM.TWOLINES && (input.length === 0 || input2.length === 0)) {
        timber.productPage({variant: null});
        return;
    }

    let lettersUsed = (charmOrientation === CHARM.TWOLINES) ? input.length + input2.length : input.length;
    let sku = `au-letter-charm-${orientationToAbbreviation(charmOrientation)}-${lettersUsed}`;

    if (!window.productVariants) {
        console.error(sku);
        throw new Error('Product variants hash is missing in window object');
    }

    let selectedVariant = window.productVariants.find((variant) => variant.sku === sku);

    /** Code below mimics product-options code **/

    timber.productPage({
        variant: selectedVariant
    });

    if (selectedVariant) {
        document.querySelector("[data-js='master-select']").value = selectedVariant.id;
        document.getElementById('gold-color').value = goldColor.description;
        document.getElementById('charm-orientation').value = charmOrientation.description;
        if (charmOrientation === CHARM.TWOLINES) {
            document.getElementById('charm-text').value = `Line one: ${input.toUpperCase()} / Line two: ${input2.toUpperCase()}`;
        } else {
            document.getElementById('charm-text').value = input.toUpperCase();
        }

        if (window.affirm) {
            window.affirm.ui.ready(function () {
                if (document.querySelector('.affirm-as-low-as')) {
                    document.querySelector('.affirm-as-low-as').setAttribute('data-amount', selectedVariant.price);
                    window.affirm.ui.refresh();
                }
            });
        }

        window.selectedVariant = selectedVariant.title;
    }
}

function orientationToAbbreviation(orientation) {
    switch (orientation) {
        case CHARM.ONELINE:
            return 'oneline';
        case CHARM.TWOLINES:
            return 'twolines';
        case CHARM.VERTICAL:
            return 'vertical';
    }
}
